import { createSlice } from '@reduxjs/toolkit';

// import newTemplate from '../Slices/newTemplate.json'
type QuestionComposition = Record<string, number>;

export type QuestionOption = {
  isActive: boolean;
  answerOption: string;
  isCorrectAnswer: boolean;
  correctAnswer: string | null;
  answerPlaceHolder: string | null;
  answerFeildType: string | null;
};

export type AdditionalProps = Record<string, unknown>;

export type Question = {
  id: string;
  isActive: boolean;
  createdDate: string;
  updatedDate: string | null;
  questionTypeId: string;
  roundId: string;
  sectionId: string;
  topicId: string;
  subTopic: string;
  questionTitle: string | null;
  questionText: string;
  explanation: string;
  options: QuestionOption[];
  correctAnswer: string;
  additionalProps: AdditionalProps;
  isProgrammingQuestion: boolean;
};

type Section = {
  sectionSortOrder: number;
  isInstructionAvailabe: boolean;
  description: string;
  instructions: string;
  isSectionDisplayAvailable: boolean;
  sectionId: string;
  totalQuestions: number;
  questionComposition: QuestionComposition;
  sectionSpanTime: number;
  sectionBreakTime: number;
  generatedSectionQuestions: Question[];
};

export type Round = {
  roundId: string;
  description: string;
  isInstructionAvailabe: boolean;
  instructions: string;
  totalRoundTime: number;
  roundSortOrder: number;
  totalSections: number;
  isRoundDisplayAvailable: boolean;
  sections: Section[];
};

export type ExamPattern = {
  id: string;
  isActive: boolean;
  companyId: string;
  yearOfPattern: number;
  examName: string;
  totalRounds: number;
  rounds: Round[];
  createdDate: string;
  updatedDate: string | null;
};

const initialState: ExamPattern[] = [
  {
    id: ' ',
    isActive: true,
    companyId: ' ',
    yearOfPattern: 2024,
    examName: 'NLA 2024',
    totalRounds: 1,
    rounds: [
      {
        roundId: ' ',
        description: '',
        isInstructionAvailabe: true,
        instructions: '',
        totalRoundTime: 5400,
        roundSortOrder: 1,
        totalSections: 4,
        isRoundDisplayAvailable: true,
        sections: [
          {
            sectionSortOrder: 1,
            isInstructionAvailabe: true,
            description: '',
            instructions: '',
            isSectionDisplayAvailable: true,
            sectionId: ' ',
            totalQuestions: 22,
            questionComposition: {
              '67f4efb712b8026f68aca58a': 10,
              '67f4efdd12b8026f68aca58b': 12
            },
            sectionSpanTime: 200,
            sectionBreakTime: 60,
            generatedSectionQuestions: []
          },
          {
            sectionSortOrder: 2,
            isInstructionAvailabe: true,
            description: '',
            instructions: '',
            isSectionDisplayAvailable: true,
            sectionId: ' ',
            totalQuestions: 13,
            questionComposition: {
              '67f4f01912b8026f68aca58c': 2,
              '67f4f03112b8026f68aca58d': 5,
              '67f4f03a12b8026f68aca58e': 6
            },
            sectionSpanTime: 600,
            sectionBreakTime: 60,
            generatedSectionQuestions: []
          },
          {
            sectionSortOrder: 3,
            isInstructionAvailabe: true,
            description: '',
            instructions: '',
            isSectionDisplayAvailable: true,
            sectionId: ' ',
            totalQuestions: 30,
            questionComposition: {
              '67f4f09712b8026f68aca58f': 30
            },
            sectionSpanTime: 1620,
            sectionBreakTime: 60,
            generatedSectionQuestions: []
          },
          {
            sectionSortOrder: 4,
            isInstructionAvailabe: true,
            description: '',
            instructions: '',
            isSectionDisplayAvailable: true,
            sectionId: ' ',
            totalQuestions: 4,
            questionComposition: {
              '67f4f0a812b8026f68aca590': 2
            },
            sectionSpanTime: 1800,
            sectionBreakTime: 60,
            generatedSectionQuestions: []
          }
        ]
      }
    ],
    createdDate: '2025-04-08T13:52:16.911',
    updatedDate: null
  }
];

const newTempleteSlice = createSlice({
  name: 'newTemplete',
  initialState,
  reducers: {
    setNewTemplete: (state, action) => {
      console.log(action.payload, 'payload2345');
      return action.payload;
    }
  }
});

export const { setNewTemplete } = newTempleteSlice.actions;
export default newTempleteSlice.reducer;
